(function () {
  'use strict';
  class Controller {
    constructor() {
      this.creationDate = new Date();
      this.$timestamp = Date.now();
    }
  }
  angular
    .module('actions')
    .component('categoryAddReviewAction', {
      controller: Controller,
      templateUrl: 'actions/category/addReview/addReview-category.action.html',
      bindings: {
        categoryId: '<',
        then: '&',
        catch: '&'
      }
    });
}());
